<template>
  <lf-card>
    <div
      class="flex h-full w-full flex-col items-center justify-center space-y-4 p-10"
    >
      <icon-base width="120" height="120" :icon="IconEmptyState" />
      <div class="flex flex-col items-center space-y-4">
        <lf-h2 class="-mb-0">
          {{
            isClosing
              ? $t("OFFERS.CLOSING.NO_APPROVED_OFFERS")
              : $t("OFFERS.EMPTY_HEADING")
          }}
        </lf-h2>
        <span
          v-if="!isClosing"
          class="w-102 text-center text-sm font-normal whitespace-pre-line text-gray-500"
        >
          {{ $t("OFFERS.EMPTY_SUBHEADING") }}
        </span>
      </div>
      <create-self-funded-offer-button
        v-if="
          !isClosing &&
          !noProducts &&
          shouldShowCreateOfferButton &&
          canCreateOffer
        "
        :disabled="(isClient && !isUnderwritingEnabled) || isClientUser"
      />
    </div>
  </lf-card>
</template>

<script setup lang="ts">
import { computed } from "vue";

import IconEmptyState from "@/components/icons/IconEmptyState.vue";
import { Ability, PermissionSubject } from "@/enums/auth";
import { useAuth } from "@/hooks/auth";
import { usePermissions } from "@/hooks/auth";
import { useDeals } from "@/hooks/deals";
import { useActiveWorkflowTemplateStages } from "@/hooks/workflow";

import CreateSelfFundedOfferButton from "./CreateSelfFundedOfferButton.vue";

defineProps<{
  isSelfFunding?: boolean;
  noProducts?: boolean;
  isClosing?: boolean;
}>();

const { canPerformActionReactive } = usePermissions();

const { hasPlacementStage } = useActiveWorkflowTemplateStages();

const { isFunder, isClient, isLendflowUser, isClientUser } = useAuth();
const { isClientFunded, isUnderwritingEnabled, activeDeal } = useDeals();

const canCreateOffer = canPerformActionReactive(
  PermissionSubject.offer,
  Ability.create,
  { application: activeDeal.value?.id }
);

const shouldShowCreateOfferButton = computed(() => {
  return (
    ((!isFunder || isClient) && isClientFunded.value) ||
    (!hasPlacementStage.value && isLendflowUser)
  );
});
</script>
